import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function InputFileUpload({ canUpload, onFileUpload }) {

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (files.length > 0) {
      const file = files[0];
      const fileType = file.type;

      const reader = new FileReader();
      if (fileType.startsWith('image/')) {
        // Procesar imagen
        reader.onloadend = () => {
          onFileUpload(reader.result, file.name, 'image');
        };
        reader.readAsDataURL(file);
      } else if (fileType === 'application/pdf' || file.name.endsWith('.docx')) {
        // Procesar PDF y DOCX
        reader.onloadend = () => {
          onFileUpload(reader.result, file.name, 'document');
        };
        reader.readAsDataURL(file);
      } else {
        console.error('Formato de archivo no soportado.');
      }
    }
  };

  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      sx={{ marginLeft: 2, height: '100%', backgroundColor: '#2B7C83' }}
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      disabled={!canUpload}
    >
      Upload
      <VisuallyHiddenInput
        type="file"
        onChange={handleFileChange}
        multiple
        accept="image/*,application/pdf,.docx"
      />
    </Button>
  );
}
